import {
  UserProfileResponse,
  FormattedUserProfileResponse
} from './contact-verification-service-types'

export const formatUserProfile = (response: UserProfileResponse): FormattedUserProfileResponse => ({
  ...response,
  documentType: response.document.type
})

export const isAllowedToSkipVerification = (
  userProfile: FormattedUserProfileResponse,
  type: 'phone' | 'email'
) => {
  return userProfile.isTest || (type === 'phone' && userProfile.documentType !== 'CPF')
}
